/**
 * Created by PanJiaChen on 16/11/18.
 */
function formatUTC(t) {
    if (t.indexOf('T') != -1) {
        var y, h; //年份,时间
        var regH = /(T| )(\d\d:\d\d:\d\d)(\.\d+)?/;// 校验时间格式
        h = t.match(regH);
        h = h && h[2]; //拿到时分秒
        y = t.slice(0, t.indexOf('T') + 1); //截取年月日
        var timestamp = new Date((y.slice(0, -1) + ' ' + h).replace(/-/g, '/')).getTime() / 1000;
        var off = new Date().getTimezoneOffset() / 60; //当前时差
        timestamp -= off * 60 * 60;
        return new Date(parseInt(timestamp) * 1000);
    }
    return new Date(t.replace(/\-/g, '/'));
}


/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
    if (!time) return '';
    if (arguments.length === 0) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date;
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time);

        if (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)) {
            date = formatUTC(time);
        }
    }

    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
    if (('' + time).length === 10) {
        time = parseInt(time) * 1000
    } else {
        time = +time
    }
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000

    if (diff < 30) {
        return '刚刚'
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
        return '1天前'
    }
    if (option) {
        return parseTime(time, option)
    } else {
        return (
            d.getMonth() +
            1 +
            '月' +
            d.getDate() +
            '日' +
            d.getHours() +
            '时' +
            d.getMinutes() +
            '分'
        )
    }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
    url = url == null ? window.location.href : url
    const search = url.substring(url.lastIndexOf('?') + 1)
    const obj = {}
    const reg = /([^?&=]+)=([^?&=]*)/g
    search.replace(reg, (rs, $1, $2) => {
        const name = decodeURIComponent($1)
        let val = decodeURIComponent($2)
        val = String(val)
        obj[name] = val
        return rs
    })
    return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
    // returns the byte length of an utf8 string
    let s = str.length
    for (var i = str.length - 1; i >= 0; i--) {
        const code = str.charCodeAt(i)
        if (code > 0x7f && code <= 0x7ff) s++
        else if (code > 0x7ff && code <= 0xffff) s += 2
        if (code >= 0xDC00 && code <= 0xDFFF) i--
    }
    return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
    const newArray = []
    for (let i = 0; i < actual.length; i++) {
        if (actual[i]) {
            newArray.push(actual[i])
        }
    }
    return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
    if (!json) return ''
    return cleanArray(
        Object.keys(json).map(key => {
            if (json[key] === undefined) return ''
            return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
        })
    ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
    const search = url.split('?')[1]
    if (!search) {
        return {}
    }
    return JSON.parse(
        '{"' +
        decodeURIComponent(search)
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"')
            .replace(/\+/g, ' ') +
        '"}'
    )
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
    const div = document.createElement('div')
    div.innerHTML = val
    return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
    if (typeof target !== 'object') {
        target = {}
    }
    if (Array.isArray(source)) {
        return source.slice()
    }
    Object.keys(source).forEach(property => {
        const sourceProperty = source[property]
        if (typeof sourceProperty === 'object') {
            target[property] = objectMerge(target[property], sourceProperty)
        } else {
            target[property] = sourceProperty
        }
    })
    return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
    if (!element || !className) {
        return
    }
    let classString = element.className
    const nameIndex = classString.indexOf(className)
    if (nameIndex === -1) {
        classString += '' + className
    } else {
        classString =
            classString.substr(0, nameIndex) +
            classString.substr(nameIndex + className.length)
    }
    element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
    if (type === 'start') {
        return new Date().getTime() - 3600 * 1000 * 24 * 90
    } else {
        return new Date(new Date().toDateString())
    }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
    let timeout, args, context, timestamp, result

    const later = function () {
        // 据上一次触发时间间隔
        const last = +new Date() - timestamp

        // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
        if (last < wait && last > 0) {
            timeout = setTimeout(later, wait - last)
        } else {
            timeout = null
            // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
            if (!immediate) {
                result = func.apply(context, args)
                if (!timeout) context = args = null
            }
        }
    }

    return function (...args) {
        context = this
        timestamp = +new Date()
        const callNow = immediate && !timeout
        // 如果延时不存在，重新设定延时
        if (!timeout) timeout = setTimeout(later, wait)
        if (callNow) {
            result = func.apply(context, args)
            context = args = null
        }

        return result
    }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
    if (!source && typeof source !== 'object') {
        throw new Error('error arguments', 'deepClone')
    }
    const targetObj = source.constructor === Array ? [] : {}
    Object.keys(source).forEach(keys => {
        if (source[keys] && typeof source[keys] === 'object') {
            targetObj[keys] = deepClone(source[keys])
        } else {
            targetObj[keys] = source[keys]
        }
    })
    return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
    return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
    const timestamp = +new Date() + ''
    const randomNum = parseInt((1 + Math.random()) * 65536) + ''
    return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
    return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
    if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
    if (hasClass(ele, cls)) {
        const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
        ele.className = ele.className.replace(reg, ' ')
    }
}

//只能输入大于0的正整数
export function limitInteger(val, canSetMin) {
    if (val == 0 && canSetMin) return 0
    if (val.length == 1) {
        val = val.replace(/[^1-9]/g, '')
    } else {
        val = val.replace(/\D/g, '')
    }
    return !val ? 1 : parseInt(val)
}

export function transDate(val, type) {
    if (!val) return
    return formatDateTime(val, type)
}

function formatDateTime(val, type) {
    var date = new Date(val);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? ('0' + minute) : minute;
    second = second < 10 ? ('0' + second) : second;
    if (type == 1) {
        return y + '-' + m + '-' + d;
    } else {
        return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
    }
};


//是否是同一天
export function isSameDay(timeStampA, timeStampB) {
    let dateA = new Date(timeStampA);
    let dateB = new Date(timeStampB);
    return (dateA.setHours(0, 0, 0, 0) == dateB.setHours(0, 0, 0, 0));
}

/**
 * handle st  reqParams
 * @param {value}
 * @returns {boolean}
 */
export function isLegalKey(value) {
    return value !== undefined &&
        value !== null &&
        value !== "" &&
        JSON.stringify(value) !== "[]"
}

// promiseQueue
export function promiseQueue(executors) {
    return new Promise((resolve, reject) => {
        if (!Array.isArray(executors)) {
            executors = Array.from(executors)
        }
        if (executors.length <= 0) {
            return resolve([])
        }

        //var res = [] //10-30 不收集response
        executors = executors.map((x, i) => () => {
            var p = typeof x === 'function' ? new Promise(x) : Promise.resolve(x)
            p.then(response => {
                //res[i] = response
                if (i === executors.length - 1) {
                    resolve(response)
                } else {
                    executors[i + 1]()
                }
            }, reject)
        })
        executors[0]()
    })
}

//隐藏历史记录tab栏
export function hiddenTableItemInPrevious() {
    const els = document.querySelectorAll(
        `#modals-container .el-tabs > .el-tabs__header > .el-tabs__nav-wrap > .el-tabs__nav-scroll > .el-tabs__nav > .el-tabs__item`
    );
    if (els.length) {
        els[els.length - 1].style.display = 'none';
    }
}

/**
 * widget/data/Region,省市区数据转换
 * */
export function transformRegionArea(data) {
    if (Array.isArray(data)) {
        data.forEach(item => {
            item.label = item.name
            item.value = item.id
            item.children && item.children.forEach(son => {
                son.label = son.name
                son.value = son.id
                son.children && son.children.forEach(child => {
                    child.label = child.name
                    child.value = child.id
                })
            })
        })
        return data
    } else {
        return []
    }
}

/***
 * 省市区数据转换
 */
export function FomartRegionData(nodes) {

    for (let node of nodes) {
        node.label = node.label || node.name;
        node.value = node.value || node.id;
        node.children && node.children.length && FomartRegionData(node.children);
    }
}

/**
 * isEmpty
 */
export function isEmpty(variable) {
    return variable == null || variable === undefined || variable === '';
}

/**
 * isNotEmpty
 */
export function isNotEmpty(variable) {
    return !isEmpty(variable);
}

/**
 * widget/data/CityRegion,城市区域数据转换,城市区域可能会有超过三级的,需要前端处理掉超过三级的数据
 * */
export function transformCityRegionArea(data) {
    if (Array.isArray(data)) {
        data.forEach(item => {
            item.label = item.name
            item.value = item.id
            item.children && item.children.forEach(son => {
                son.label = son.name
                son.value = son.id
                son.children && son.children.forEach(child => {
                    child.label = child.name
                    child.value = child.id
                    child.children = null
                })
            })
        })
        return data
    } else {
        return []
    }
}

/**
 * 针对数组里对象里的某个属性进行排序
 */
export function arraySort(array, propetry) {
    const compare = propetry => {
        return (a, b) => {
            let v1 = a[propetry];
            let v2 = b[propetry];
            return v1 - v2;
        };
    };
    return array.length == 0 ? array : array.sort(compare(propetry));
}

/**
 * 只合并key少的对象
 */
export function mergeObj(obj1 = {}, obj2 = {}, customObj = {}) {
    const obj = Object.assign({}, obj2, customObj);
    Object.keys(obj1).forEach((item) => {
        if (isNotEmpty(obj[item])) {
            obj1[item] = obj[item]
        }
    })
}

/**
 * 小数转换百分比
 */
export function percentage(value) {
    if (typeof value != 'number') {
        return '';
    }
    return `${value * 100}%`;
}


export const To = promise => promise.then(data => [null, data]).catch(err => [err, null])

export function blobToDataURI(blob, callback) {
    var reader = new FileReader();
    reader.onload = function (e) {
        callback(e.target.result);
    }
    reader.readAsDataURL(blob);
}

//当年的第一天
export function yearsOneDay() {
    return `${new Date().getFullYear()}-01-01`
}

//导出Excel
export function exportExcel(res, fileName) {
    const link = document.createElement('a')
    let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
    });
    link.style.display = 'none'
    link.href = URL.createObjectURL(blob)
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

export function resetNullData(data) {
    if (data && Object.prototype.toString.call(data) === '[object Object]') {
        for (let key in data) {
            if (data[key] === null || data[key] === undefined) {
                data[key] = ''
            }
        }
    }
    return data
}

export function filterNullToZero(val) {
    if (val === 0) {
        return val;
    } else {
        val =
            val &&
            val !== null &&
            val !== 'null' &&
            val !== undefined &&
            val !== 'undefined'
                ? val
                : 0;
        return val;
    }
}

export function getLoginPath() {
    let loginPath
    switch (localStorage.getItem('platform')) {
        case '哲水':
            loginPath = '/zslogin'
            break;
        case '颐酌':
            loginPath = '/yzlogin'
            break;
        case '琨伦':
            loginPath = '/kllogin'
            break;
        case '慧车':
            loginPath = '/hclogin'
            break
        default:
            loginPath = '/zslogin'
            break
    }
    return loginPath
}

function doHandMonth(month) {
    var m = month
    if (month.toString().length == 1) {
        m = "0" + month
    }
    return m
}

// getDate(-90) 获取90天前的日期
export function getDate(day) {
    let today = new Date()
    let targetDay = today.getTime() + 1000 * 60 * 60 * 24 * day
    today.setTime(targetDay)
    let tYear = today.getFullYear()
    let tMonth = today.getMonth()
    let tDate = today.getDate()
    tMonth = doHandMonth(tMonth + 1)
    tDate = doHandMonth(tDate)
    return tYear + "-" + tMonth + "-" + tDate
}

export function diffMonth(date,n){
    let dt = new Date(date);
    dt.setMonth(dt.getMonth() + Number(n));
    return dt.toLocaleString().replace(/\//g, '-') ;
}




// WEBPACK FOOTER //
// ./src/utils/index.js